export const TEST_ID = 'rateLegend';

export const TEST_ID_BIN = 'rateLegendBin';
